import WebNoMessageHelp1 from "@/assets/images/web_noMessage_help_1.png";
import WebNoMessageHelp2 from "@/assets/images/web_noMessage_help_2.png";
import WebNoMessageHelp3 from "@/assets/images/web_noMessage_help_3.png";
import WebNoMessageHelp4 from "@/assets/images/web_noMessage_help_4.png";
import WebNoMessageHelp5 from "@/assets/images/web_noMessage_help_5.png";

export default function WebNoMessageHelp() {
  return (
    <div className="px-6.5">
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        1. 点击左下麦克风icon，切换至合适的拾音设备
      </div>
      <img src={WebNoMessageHelp1} className="w-full mb-8" />
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        2. 未开启系统对AI会记应用的麦克风权限
      </div>
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Macbook 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「系统偏好设置」，选择「安全性与隐私」➡️
        点击页面上方「隐私」tab目录➡️
        在左侧栏选择「麦克风」，勾选你使用的浏览器（以 Chrome
        浏览器为例），开启麦克风权限➡️ 刷新MAXHUB会记页面，即可完成设置
      </div>
      <img src={WebNoMessageHelp2} className="w-full mb-8" />
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Windows 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「设置」，选择「隐私」➡️
        在左侧打开应用权限中的「麦克风」选项，在「允许
        桌面应用访问你的麦克风」中选择开启➡️
        刷新AI会记页面，即可完成设置
      </div>
      <img src={WebNoMessageHelp3} className="w-full mb-8" />
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        3. 查看声音输入设备是否正常
      </div>
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Macbook 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「系统偏好设置」，选择「声音」➡️
        选择「输入」，测试当前输入设备是否可用
      </div>
      <img src={WebNoMessageHelp4} className="w-full mb-8" />
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Windows 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「设置」，选择「隐私」➡️
        在左侧打开应用权限中的「麦克风」选项，在「允许桌面应用访问你的麦克风」中选择开启
      </div>
      <img src={WebNoMessageHelp5} className="w-full mb-8" />
    </div>
  );
}
